// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-icon[data-v-24569105]{position:absolute;top:0;right:0;color:#474647}.header[data-v-24569105]{min-height:150px;display:flex;flex-direction:column;font-size:24px}.btns[data-v-24569105],.header[data-v-24569105]{text-align:center}.btns>*[data-v-24569105]{width:200px}", ""]);
// Exports
module.exports = exports;
